import { useEffect, useState } from "react";

import { HeaderDesktop } from "Components/organisms/Header/Desktop";
import { HeaderMobile } from "Components/organisms/Header/Mobile";
import { useBreakpoint } from "shared/hooks/useBreakpoint";

/**
 * Componente HeaderTemplate
 *
 * Renderiza o cabeçalho alternando entre as versões Desktop e Mobile
 * com base no tamanho da tela.
 */
export function HeaderTemplate() {
  const [desktop, setDesktop] = useState(true);
  const breakpoint = useBreakpoint();

  useEffect(() => {
    setDesktop(
      breakpoint === "xxl" || breakpoint === "xl" || breakpoint === "lg",
    );
  }, [breakpoint]);

  return desktop ? <HeaderDesktop /> : <HeaderMobile />;
}
